export enum OrganisationCommunicationType {
    specialist = 'specialist',
    responsible = 'responsible',
    reminder = 'reminder'
}
